<template>
  <div id="userAdd">
    <!-- 个人信息 -->
    <el-form :inline="true" class="demo-ruleForm" :model="tempexamUser"  label-width="80px" label-position="right" :rules="rules" ref="examrefUser">
      <el-row>
        <el-col :span="8">
          <el-form-item label="用户名" prop="username" id="username" >
            <el-input v-model="tempexamUser.username" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="真实姓名" prop="realname" id="realname" >
            <el-input v-model="tempexamUser.realname" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="性别" prop="sex" >
            <el-select v-model="tempexamUser.sex" placeholder="请选择" class="dialogDataWidth" style="width:100%">
              <el-option v-for="item in options_sex" :key="item.code" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="手机" prop="mobile" id="mobile" >
            <el-input v-model="tempexamUser.mobile" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="座机" prop="tel" id="tel" >
            <el-input v-model="tempexamUser.tel" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="邮箱" prop="email" id="email" >
            <el-input v-model="tempexamUser.email" :maxlength="25" placeholder="请输入内容" class="DataWidth" suffix-icon="XXX">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="角色" prop="roleIdsTemp">
            <el-select v-model="roleIdsTemp" multiple>
              <el-option v-for="item in options_roleType" :key="item.id"
                         :label="item.roleName"
                         :value="item.id">
                <span style="float: left">{{ item.roleName }}</span>
                <span v-if="item.roleType==1" style="float: right; color: #8492a6; font-size: 13px">功能性角色</span>
                <span v-if="item.roleType==2" style="float: right; color: #8492a6; font-size: 13px">岗位性角色</span>
              </el-option>

            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="隶属部门" prop="deptId" >
            <el-cascader v-model="tempexamUser.deptId" placeholder="请选择隶属部门" :options="alldeps" :props="deptProps" ref="cascaderDept" :show-all-levels="false">
            </el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="状态" prop="status" id="status" >
            <el-select v-model="tempexamUser.status" placeholder="请选择" class="dialogDataWidth">
              <el-option v-for="item in options_status" :key="item.code" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="身份证" prop="identityId" >
            <el-input v-model="tempexamUser.identityId" placeholder="请输入身份证" class="DataWidth"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排序" prop="sort" >
            <el-input v-model.number="tempexamUser.sort" placeholder="请输入内容" class="DataWidth"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <!-- 功能按钮 -->
    <el-row style="margin-top:15px">
      <el-col :span="20"><span class="bs">新增用户默认密码：888888</span></el-col>
      <el-col :span="2">
        <el-button type icon @click="reset">关闭</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="save" @click="save">保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import StringUtil from "../../utils/StringUtil";

export default {
  data() {
    const isMail = (rule, value, callback) => {
      var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if ($.isEmptyObject(value)){
          callback()
        }else {
      if (!reg.test(value)) {
        callback(new Error('邮件格式不正确'))
      }else{
        callback()
      }
        }
    };
    const isMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号'));
        } else {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error('手机号格式不正确'))
      }else{
        callback()
      }}
    };
    const isNum = (rule, value, callback) => {
      const reg = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,4}))?$/;
      const tel = /^\d{3,4}-?\d{6,9}$/;
      if ($.isEmptyObject(value)){
        callback()
      }else {
        if (!tel.test(value)) {
          callback(new Error('座机号格式不正确'))
        }else{
          callback()
        }
      }
    };
    return {
      tempexamUser:{},
      alldeps: [],
      roleIdsTemp: [],
      deptProps: {
        label: "label",
        value: "id",
        children: "children",
        emitPath: false,
        checkStrictly: true
      },
      jsList: [],
      options_sex: [],
      options_roleType: [],
      options_status: [],
      // 测试验证
      rules: {
        username: [
          { required: true, message: "请填写用户名", trigger: "blur" }
        ],
        realname: [
          { required: true, message: "请填写真实姓名", trigger: "blur" }
        ],
        mobile: [{validator:isMobile , required: true, trigger: "blur" }],
        // tel: [
        //   { validator:isNum , required: false,trigger: "blur" }
        // ],
        email: [
          { validator:isMail , required: false ,trigger: "blur" }
        ],
        deptId: [{ required: true, message: "请选择部门", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }]
      }
    };
  },
  created(){
    this.tempexamUser = this.examUser
  },
  props: ["isSave", "examUser"],
//  watch: {
//    tempexamUser: function(newObj, oleObj) {
//      this.roleIdsTemp = newObj.roleId;
//    }
//  },
  mounted: function() {
    this.options_sex = this.CommonUtil.getIntCodeList("sex");
    this.options_status = this.CommonUtil.getCodeList("status");
    this.getRoleList();
    this.getDetpTree();
    this.roleIdsTemp = this.tempexamUser.roleId;
  },
  methods: {
    getDetpTree: function() {
      let that = this;
      this.$axios.get("/department/departmentTree").then(response => {
        if (
          response.data !== null &&
          response.data !== "" &&
          response.data !== undefined
        ) {
          that.alldeps = JSON.parse(response.data);
        }
      });
    },
    //查询角色代码
    getRoleList: function() {
      var url = "/role/allroleList";
      this.$axios.get(url).then(response => {
        if (
          response.data !== null &&
          response.data !== "" &&
          response.data !== undefined
        ) {
          this.options_roleType = response.data;
        }
      });
    },
    reset: function() {
      this.roleIdsTemp = [];
      this.$refs["examrefUser"].resetFields();
      this.$emit("closeUser");
    },
    // 保存
    save: function() {
      if (this.roleIdsTemp.length <= 0) {
        this.$message({
          message: "请选择至少一种角色",
          type: "warning"
        });
        return false;
      }
      this.$refs["examrefUser"].validate(valid => {
        if (valid) {
          this.tempexamUser.deptIds = "";
          var nodeList = this.$refs["cascaderDept"].getCheckedNodes()[0]
            .pathNodes;
          var tempList = [];
          for (var i = 0; i < nodeList.length; i++) {
            tempList.push(Number(nodeList[i].value));
          }
          this.tempexamUser.deptIds = tempList.join(",");
          this.tempexamUser.userroles = [];
          this.tempexamUser.jqId = 1;
          this.roleIdsTemp.forEach((roleId, index) => {
            this.tempexamUser.userroles.push({ userId: "", roleId: roleId }); //新用户没有userid
          });
          this.$axios.post("/user/userAdd", this.tempexamUser).then(res => {
            if (res.code == "0000") {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.reset();
              this.$emit("closeUser");

            } else {
              this.$message({
                message: res.message,
                type: "warning"
              });
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped>
div {
  margin-top: 0px;
}

.c {
  margin-top: 10px;
}
.right
{
  float: right;
}
.bs{
  float: left;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue